import React, { useEffect, useState } from "react";
import EditProductComponent from "./edit-product.page";
import { useRouteMatch, useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { ROOT } from "../../config/product-mgmt.route";
import { getProduct } from "../../redux/action/products.action";
import { selectLoading } from "modules/notification";
import { unwrapResult } from "@reduxjs/toolkit";
import {AccessRights} from "lib/constants/accessRights";
import { setEditorMode, setIsInProductPage } from "modules/product-mgmt/redux/slice/productPage.slice";
import LoadingComponent from "components/loading";
import {canAccess} from "../../../profile/redux/selector/profile.selector";
import { getLang } from "app/feature/constants";
import GeneralDialog from "components/dialog/generalDialog";

function EditProductContainer({
  resetPageEditor,
  getProduct,
  isLoading,
  setIsInProductPage,
}) {
  const history = useHistory();
  const match = useRouteMatch();
  const id = match.params.productId;
  const hasProductViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Product.LISTING_READ)
  );
  const hasProductEditAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Product.LISTING_UPDATE));
  const canViewLandingPage = useSelector(state =>
    canAccess(state, AccessRights.Product.LANDING_PAGE_READ));
  const canEditLandingPage = useSelector(state =>
    canAccess(state, AccessRights.Product.LANDING_PAGE_WRITE));

  const lang = useSelector((state) => state.constant.languages);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [newPicturePending, setNewPicturePending] = useState(false);
  const [newUploadPicture, setNewUploadPicture] = useState("");

  const [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(false);
  const [isStatusUpdating] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [dialogState, setDialogState] = useState("");

  useEffect(() => {
    if (!hasProductViewAccessRight) {
      history.push("/admin/dashboard");
    }
  }, [history, hasProductViewAccessRight]);

  const handleChange = (event, index) => {
    if (isEditing || newPicturePending) {
      setIsDiscardDialogOpen(true);
      setSelectedIndex(index);
      setDialogState("change");
      // setNewPicturePending(false);
      // setNewUploadPicture("");
    } else {
      setActiveIndex(index);
    }
  };

  const handleDialogAction = () => {
    if (dialogState === "back") {
      history.goBack();
    } else if (dialogState === "change") {
      // setIsStatusUpdating(true);
      setActiveIndex(selectedIndex);
      setIsEditing(false);
      setNewPicturePending(false);
      setNewUploadPicture("");
    }
    setIsDiscardDialogOpen(false);
  };

  const handleBack = (originalOnClick) => {
    if (isEditing || newPicturePending) {
      setIsDiscardDialogOpen(true);
      setDialogState("back");
    } else {
      originalOnClick();
    }
  };

  useEffect(() => {
    if (id) {
      getProduct(id)
        .then(unwrapResult)
        .catch(() => history.push(ROOT));
    } else {
      history.push(ROOT);
    }

    setIsInProductPage(true);
    return () => {
      setIsInProductPage(false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    resetPageEditor();
  }, [resetPageEditor]);

  if (!hasProductViewAccessRight) return <LoadingComponent />;

  const tabs = [];
  tabs.push(getLang(lang,"label.PRODUCT_INFO"));
  if (canViewLandingPage) {
    tabs.push(getLang(lang,"label.LANDING_PAGE"));
  }

  return (
    <>
      <EditProductComponent
        hasProductEditAccessRight={hasProductEditAccessRight}
        isLoading={isLoading}
        activeIndex={activeIndex}
        handleChange={handleChange}
        handleBack={handleBack}
        lang={lang}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        newPicturePending={newPicturePending}
        setNewPicturePending={setNewPicturePending}
        newUploadPicture={newUploadPicture}
        setNewUploadPicture={setNewUploadPicture}
        canViewLandingPage={canViewLandingPage}
        canEditLandingPage={canEditLandingPage}
        tabs={tabs}
      />
      <GeneralDialog
        isLoading={isStatusUpdating}
        isOpen={isDiscardDialogOpen}
        handleClose={() => setIsDiscardDialogOpen(false)}
        handleProceed={() => handleDialogAction()}
        title={getLang(lang, "label.DISCARD_CHANGES")}
        description={getLang(lang, "paragraph.DISCARD_CHANGES_DESC")}
        type="danger"
        proceedLabel={getLang(lang, "label.CONFIRM")}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  isLoading: selectLoading(state, getProduct.typePrefix),
});

const mapDispatchToProps = (dispatch) => ({
  resetPageEditor: () => {
    dispatch(setEditorMode(false));
  },
  getProduct: (id) => dispatch(getProduct(id)),
  setIsInProductPage: (value) => dispatch(setIsInProductPage(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProductContainer);
